import '../../../../neb-lit-components/src/components/inputs/neb-textfield';
import '../../../../neb-lit-components/src/components/inputs/neb-select';
import '../../../../neb-lit-components/src/components/neb-button';
import '../../../../neb-lit-components/src/components/field-groups/neb-phone-item';

import { isRequired } from '@neb/form-validators';
import { html, css } from 'lit';

import NebForm from '../../../../neb-lit-components/src/components/forms/neb-form';
import { SEX } from '../../../../neb-lit-components/src/components/patients/neb-patient-profile-data';
import { baseStyles } from '../../../../neb-styles/neb-styles';
import {
  CSS_SPACING,
  CSS_COLOR_HIGHLIGHT,
  CSS_FONT_WEIGHT_BOLD,
} from '../../../../neb-styles/neb-variables';
import { date } from '../../../../neb-utils/masks';
import { dateOfBirth, phoneNumber } from '../../../../neb-utils/selectors';

export const ELEMENTS = {
  createAccountButton: { id: 'create-account-button' },
  givenName: { id: 'given-name' },
  familyName: { id: 'family-name' },
  birthdate: { id: 'birthdate' },
  phone: { id: 'phone' },
  email: { id: 'email' },
  sex: { id: 'sex' },
};

const PHONE_HELPERS = { number: 'Required', type: 'Required' };

export class NebFormCreateAccount extends NebForm {
  static createModel() {
    return {
      givenName: '',
      familyName: '',
      birthdate: '',
      email: '',
      sex: '',
      phone: {
        number: '',
        type: '',
      },
    };
  }

  static get properties() {
    return {
      emailFromInvite: {
        type: String,
      },
    };
  }

  static get styles() {
    return [
      baseStyles,
      css`
        :host {
          display: block;
        }

        .button {
          margin: ${CSS_SPACING} 0;
        }

        .title {
          color: ${CSS_COLOR_HIGHLIGHT};
          font-weight: ${CSS_FONT_WEIGHT_BOLD};
          margin-bottom: ${CSS_SPACING};
        }

        .form {
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-gap: 10px ${CSS_SPACING};
          grid-template-areas:
            'given-name family-name'
            'date-of-birth sex'
            'phone phone'
            'email .';
        }

        :host([layout='small']) .form {
          grid-template-areas:
            'given-name given-name'
            'family-name family-name'
            'date-of-birth sex'
            'phone phone'
            'email email';
        }

        .given-name {
          grid-area: given-name;
        }

        .family-name {
          grid-area: family-name;
        }

        .date-of-birth {
          grid-area: date-of-birth;
        }

        .sex {
          grid-area: sex;
        }

        .phone {
          grid-area: phone;
        }

        .email {
          grid-area: email;
        }
      `,
    ];
  }

  update(changedProps) {
    if (changedProps.has('emailFromInvite') && this.emailFromInvite) {
      this.handlers.change({ name: 'email', value: this.emailFromInvite });
    }

    super.update(changedProps);
  }

  createSelectors() {
    return {
      children: {
        givenName: [isRequired()],
        familyName: [isRequired()],
        birthdate: dateOfBirth({ validators: [isRequired()] }),
        sex: [isRequired()],
        email: [isRequired()],
        phone: {
          children: {
            number: phoneNumber({ validators: [isRequired()] }),
            type: [isRequired()],
          },
        },
      },
    };
  }

  renderActionBar() {
    return html`
      <neb-button
        id="${ELEMENTS.createAccountButton.id}"
        class="button"
        label="CREATE ACCOUNT"
        .onClick="${this.handlers.save}"
      ></neb-button>
    `;
  }

  renderHeader() {
    return html` <div class="title">Create an account</div> `;
  }

  renderContent() {
    return html`
      <div class="form">
        <neb-textfield
          id="${ELEMENTS.givenName.id}"
          class="given-name"
          label="First Name"
          helper="Required"
          name="givenName"
          .value="${this.state.givenName}"
          .error="${this.errors.givenName}"
          .onChange="${this.handlers.change}"
        ></neb-textfield>

        <neb-textfield
          id="${ELEMENTS.familyName.id}"
          class="family-name"
          label="Last Name"
          helper="Required"
          name="familyName"
          .value="${this.state.familyName}"
          .error="${this.errors.familyName}"
          .onChange="${this.handlers.change}"
        ></neb-textfield>

        <neb-textfield
          id="${ELEMENTS.birthdate.id}"
          label="Date of Birth"
          class="date-of-birth"
          helper="Required"
          name="birthdate"
          .mask="${date}"
          .inputMode="${'numeric'}"
          .value="${this.state.birthdate}"
          .error="${this.errors.birthdate}"
          .onChange="${this.handlers.change}"
        ></neb-textfield>

        <neb-select
          id="${ELEMENTS.sex.id}"
          class="sex"
          label="Sex"
          helper="Required"
          name="sex"
          .items="${SEX}"
          .value="${this.state.sex}"
          .error="${this.errors.sex}"
          .onChange="${this.handlers.change}"
        ></neb-select>

        <neb-phone-item
          id="${ELEMENTS.phone.id}"
          class="phone"
          name="phone"
          .helpers="${PHONE_HELPERS}"
          .model="${this.state.phone}"
          .errors="${this.errors.phone}"
          .onChange="${this.handlers.change}"
        ></neb-phone-item>

        <neb-textfield
          id="${ELEMENTS.email.id}"
          class="email"
          inputMode="email"
          label="E-mail"
          helper="Required"
          name="email"
          .value="${this.state.email}"
          .error="${this.errors.email}"
          .onChange="${this.handlers.change}"
          ?disabled="${!!this.emailFromInvite}"
        ></neb-textfield>
      </div>
    `;
  }
}

customElements.define('neb-form-create-account', NebFormCreateAccount);
